import React from 'react'
import { Navigate, useLocation, useParams } from 'react-router-dom'
import type { Params, To } from 'react-router-dom'

export type RedirectProps = {
  to: string
}

const createTo = (to: To, params: Params, search: string): To => {
  const pathname = typeof to === 'string' ? to : to.pathname || ''
  const keys = Object.keys(params)

  return {
    pathname: keys.reduce(
      (previous, key) => previous.replace(`:${key}`, params[key] || ''),
      pathname,
    ),
    search,
  }
}

export const Redirect = ({ to }: RedirectProps) => {
  const params = useParams()
  const location = useLocation()

  return <Navigate to={createTo(to, params, location.search)} replace />
}
